// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { shieldCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-shield-check': IconShieldCheck;
    }
}

/**
 * The icon component for the 'shieldCheck' icon
 */
export class IconShieldCheck extends IconSvg {
    public constructor() {
        super(shieldCheck16X16);
    }
}

registerIconSvg('icon-shield-check', IconShieldCheck);
export const iconShieldCheckTag = 'nimble-icon-shield-check';
